import { Icon } from '@iconify/react';
import linkedinFill from '@iconify/icons-eva/linkedin-fill';
import twitterFill from '@iconify/icons-eva/twitter-fill';
import { Link as ScrollLink } from 'react-scroll';
import { Link as RouterLink } from 'react-router-dom';
// material
import { styled } from '@mui/material/styles';
import { Grid2 as Grid, Link, Divider, Container, Typography, IconButton, Stack } from '@mui/material';
// routes
import { PATH_APP, PATH_PAGE } from 'routes/paths';
//
import Logo from 'components/Logo';

// ----------------------------------------------------------------------

const SOCIALS = [
  { name: 'LinkedIn', icon: linkedinFill, href: 'https://www.linkedin.com/' },
  { name: 'Twitter', icon: twitterFill, href: 'https://twitter.com/' },
];

const LINKS = [
  {
    headline: 'Platform',
    children: [
      { name: 'Features', href: PATH_APP.admin.mobeatPlatformGuide },
      { name: 'Pricing', href: PATH_PAGE.pricing },
      { name: 'Documentation', href: PATH_APP.admin.mobeatPlatformGuide },
    ],
  },
  {
    headline: 'Resources',
    children: [
      { name: 'Help Center', href: PATH_APP.admin.mobeatPlatformGuide },
      { name: 'Developer API', href: '#' },
    ],
  },
  {
    headline: 'Company',
    children: [
      { name: 'Privacy Policy', href: '#' },
      { name: 'Terms of Service', href: '#' },
    ],
  },
];

const RootStyle = styled('div')(({ theme }) => ({
  position: 'relative',
  backgroundColor: theme.palette.background.default,
}));

// ----------------------------------------------------------------------

export default function MainFooter() {
  return (
    <RootStyle>
      <Divider />
      <Container maxWidth='lg' sx={{ pt: 10 }}>
        <Grid
          container
          justifyContent={{ xs: 'center', md: 'space-between' }}
          sx={{ textAlign: { xs: 'center', md: 'left' } }}
        >
          <Grid sx={{ mb: 3 }} size={12}>
            <ScrollLink to='move_top' spy smooth>
              <Logo sx={{ mx: { xs: 'auto', md: 'inherit' } }} />
            </ScrollLink>
          </Grid>
          <Grid
            size={{
              xs: 8,
              md: 3
            }}>
            <Typography variant='body2' sx={{ pr: { md: 5 } }}>
              Mobeat helps subscription businesses track, analyze, and optimize their revenue with powerful analytics
              and automation tools.
            </Typography>

            <Stack
              spacing={1.5}
              direction='row'
              justifyContent={{ xs: 'center', md: 'flex-start' }}
              sx={{ mt: 5, mb: { xs: 5, md: 0 } }}
            >
              {SOCIALS.map((social) => (
                <IconButton
                  key={social.name}
                  color='primary'
                  sx={{ p: 1 }}
                  component='a'
                  href={social.href}
                  target='_blank'
                  rel='noopener'
                >
                  <Icon icon={social.icon} width={16} height={16} />
                </IconButton>
              ))}
            </Stack>
          </Grid>

          <Grid
            size={{
              xs: 12,
              md: 7
            }}>
            <Stack spacing={5} direction={{ xs: 'column', md: 'row' }} justifyContent='space-between'>
              {LINKS.map((list) => {
                const { headline, children } = list;
                return (
                  <Stack key={headline} spacing={2}>
                    <Typography component='p' variant='overline'>
                      {headline}
                    </Typography>
                    {children.map((link) => (
                      <Link
                        to={link.href}
                        key={link.name}
                        color='inherit'
                        variant='body2'
                        component={RouterLink}
                        sx={{ display: 'block' }}
                      >
                        {link.name}
                      </Link>
                    ))}
                  </Stack>
                );
              })}
            </Stack>
          </Grid>
        </Grid>

        <Typography
          component='p'
          variant='body2'
          sx={{
            mt: 10,
            pb: 5,
            fontSize: 13,
            textAlign: { xs: 'center', md: 'left' },
          }}
        >
          © {new Date().getFullYear()} Mobeat. All rights reserved
        </Typography>
      </Container>
    </RootStyle>
  );
}
